import { getDownloadURL, ref} from 'firebase/storage'
import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import HomeCarousel from '../components/bootstrap/Carousel'
import EmptyListState from '../components/EmptyListState'
import Footer from '../components/Footer'
import ListingPanelFallback from '../components/ListingPanelFallback'
import PageWrapper from '../components/PageWrapper'
import PresetRentalCard from '../components/presets/PresetRentalCard'
import PresetTourCard from '../components/presets/PresetTourCard'
import LocalBusinessJsonLd from '../components/seo/LocalBusinessJsonLd'
import PageSeo from '../components/seo/PageSeo'
import SideMenu from '../components/SideMenu'
import { storage } from '../firebase'
import { fetchFirestoreList } from '../utils/fetchFirestoreList'
import '../customstyles/CustomPageEffects.css'
import '../customstyles/CustomMobileStyles.css'
import '../customstyles/CustomScrollAnimations.css'
import ScrollIntersectionObserver from '../components/CustomControls/ScrollIntersectionObserver'
import HeroBackground from '../components/HeroBackground'


export default function Dashboard() {
  const tourCollectionName = "Tours";
  const locationCollectionName = "Location";
  const rentalCollectionFilter = "Rentals";

  const [tours, setTours] = useState([]);
  const [locations, setLocations] = useState([]);
  const [rentals, setRentals] = useState([]);
  const [carouselLocations, setCarouselLocations] = useState([]);
  const [listingsError, setListingsError] = useState(null);

  useEffect(() => {
    let active = true
    ;(async () => {
      const [tourResult, locationResult, rentalResult] = await Promise.all([
        fetchFirestoreList(tourCollectionName),
        fetchFirestoreList(locationCollectionName),
        fetchFirestoreList(rentalCollectionFilter),
      ])
      if (!active) return
      setTours(tourResult.items)
      setLocations(locationResult.items)
      setRentals(rentalResult.items)
      setListingsError(tourResult.error || locationResult.error || rentalResult.error)
    })()
    return () => {
      active = false
    }
  }, [])

 
  useEffect(() => {

    const getImages = async () => {
       
        locations.forEach(location => {
          if(location.media){
            var previd = "";
            location.media.forEach(media => {
                  getDownloadURL(ref(storage, media.url)).then((url) => {
                      console.log(url, previd, location.id);
                      media.url = url;
                      console.log("media", media);
                      if(previd != location.id){
                        previd = location.id 
                        console.log(previd, location.id);
                        setCarouselLocations(prev => [...prev, location]);
                      } 
                  })
                  console.log("location = " + JSON.stringify(location)); 
              })
          }
          console.log("carouselLocation = " + JSON.stringify(carouselLocations)); 
      });
        
      }
  
      if(locations)
        getImages();

}, [locations])



  return (
    <motion.div id='outer-page-wrapper'
      initial={{ y: -150, opacity: 0}}
      animate={{ y:0, opacity: 1}}
      exit={{ opacity: 0 }}>
        <PageSeo h1="Welcome Traveler" />
        <LocalBusinessJsonLd />
        <SideMenu pageWrapId={'outer-page-wrapper'} outerContainerId={'inner-page-wrapper'} />
          <div className='parallax-header'>
            <HeroBackground />
            <PageWrapper id='inner-page-wrapper' locations={locations} name={'Dashboard'} display={<h1 className='text-dark txt-big'>
              Welcome <span className='txt-green par-h1  txt-shadow'>Tra</span><span className='txt-gold par-h1  txt-shadow'>vel</span><span className='txt-red par-h1  txt-shadow'>ler</span></h1>}>
              <span className='txt-cream txt-shadow par-txt hero-value-line'>Jamaica tours, airport shuttles &amp; bus rental</span>
            </PageWrapper>
            <div className="hero-cta-row container text-center">
              <Link className="btn btn-lg hero-cta-primary" to="/tours">Book now</Link>
            </div>
          </div>

          <div className='parallax-top'>
            {listingsError ? (
              <EmptyListState
                title="Some listings could not load"
                message="You can still browse our services while we restore live inventory."
                permissionHint="Deploy updated Firestore rules to enable public read on Tours, Rentals, and Location."
                actionTo="/tours"
                actionLabel="Browse tours"
              />
            ) : null}
            <Row className={'mt-3 text-md'}>
              <Col className='d-flex mb-3 rg-card-holder'>
                <div id='rgCardHome' className="rg-card border-turq">
                  <div className="rg-card-content">
                      <p className='lead fs-2'>
                        Visiting Jamaica? Start Planning Your Trip With Us Today!
                      </p>
                  </div>
                  <ScrollIntersectionObserver element='rgCardHome'/>
                  <Link className='btn btn-lg bt-cream rg-card-btn' to={"/tours"}>
                    Book a ride with us &nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                    </svg>

                  </Link>
                </div>
              </Col>
              <Col className='carousel1 d-flex justify-content-center col-lg-8 col-sm-12'>
              <ScrollIntersectionObserver element='bs-carousel' isClass={true} />
                {carouselLocations.length > 0 ? (
                  <HomeCarousel locations={carouselLocations} />
                ) : (
                  <ListingPanelFallback alt="Jamaica destination scenery" />
                )}
              </Col>
            </Row>

            <hr className='my-3' />

            <Row>
              <div className='rg-heading'>
                <h2 className='lead fs-1'><strong>Tour Our <span className='txt-mint'>Is</span><span className='txt-gold'>la</span><span className='txt-red'>nd</span></strong></h2>
                <h3 className='lead fs-4'>...with avariety of exciting experiences that you will only get in Jamaica, 
                the land known for it's rich vegetation, majestic rivers and coastal waters. Explore and 
                see what gems you can find.</h3>
              </div>

              <Row className={'text-md'}>
                <Col className='d-flex col-lg-4 tr-more rg-card-holder'>
                <ScrollIntersectionObserver element='rgCardTours' />
                  <div id='rgCardTours' className="rg-card border-turq">
                    <div className="rg-card-content">
                      <p className='lead fs-2'>
                        Choose from a variety of trips around our beautiful island.
                      </p>
                    </div>
                    <Link className='btn btn-lg bt-cream rg-card-btn' to={"/trips"}>
                      Current trips &nbsp;
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                      </svg>
                    </Link>
                  </div>
                </Col>
                <Col id='trGrid' className='tr-grid col-lg-8'>
                  {tours.slice(0,2).map((tour) => (
                      <PresetTourCard key={'dash' + tour.id} tour={tour} />
                  ))}
                  {tours.length === 0 && (
                    <>
                      <ListingPanelFallback alt="Jamaica island tour scenery" />
                      <EmptyListState
                        title="Trips coming soon"
                        message="Scheduled trips will show here when published."
                        actionLabel="View trips page"
                        actionTo="/trips"
                      />
                    </>
                  )}
                </Col>
              </Row>
            </Row>

            <hr className='my-3' />

            <Row>
            <div className='rg-heading'>
              <h2 className='lead fs-1'><strong>Rent A <span className='txt-mint'>Car</span> <span className='txt-gold'>With</span> <span className='txt-red'>Us</span></strong></h2>
              <h3 className='lead fs-4'>...and enjoy exploring the beautiful scenic island of Jamaica, ensure your safety with
              a high quality vehicle, the rest is up to you and your're adventurous spirit.</h3>
            </div>
            <Row className={'text-md'}>
              <Col className='d-flex col-lg-4 tr-more rg-card-holder'>
              <ScrollIntersectionObserver element='rgCardRent' />
                <div id='rgCardRent' className="rg-card border-turq">
                  <div className="rg-card-content">
                    <p className='lead fs-2'>
                      Take your adventure into your own hands
                    </p>
                  </div>
                  <Link className='btn btn-lg bt-cream rg-card-btn' to={"/rentals"}>
                    Rent a Car &nbsp;
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
                    </svg>
                  </Link>
                </div>
              </Col>
              <Col className='rent-grid col-lg-8'>
                {rentals.slice(0,2).map((rental) => (
                    <div key={rental.id + 'div'}>
                      <PresetRentalCard className={'col-sm-12 col-md-6 col-lg-4'} rental={rental} />
                    </div>
                ))}
                {rentals.length === 0 && (
                  <>
                    <ListingPanelFallback alt="Jamaica rental travel scenery" />
                    <EmptyListState
                      title="Rentals coming soon"
                      message="Vehicles will appear here when inventory is published."
                      actionLabel="Rentals page"
                      actionTo="/rentals"
                    />
                  </>
                )}
              </Col>
            </Row>
          </Row>
        </div>

        <Footer></Footer>
    </motion.div>
  )
}

